import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'
import { ajax } from '../assets/js/ajax'
function userCenter (to, from, next) {
  let id = sessionStorage.getItem("id");
  let cert = store.state.certificationStatus
  if (id != undefined) { //登录了
    if (cert == 2) { //认证了
      next();
    } else {
      if (cert == 1) { //待审核 
        next(false)
      } else {
        if (cert == '') { // 刷新后vuex数据没了
          ajax('/pc/company/getCompanyOne', { id: id }, 'POST').then((res) => {
            if (res.data.certificationStatus == 2) { //认证了
              next();
            } else {
              if (res.data.certificationStatus == 1) { //待审核
                next(false)
              } else { //未认证
                next({ path: '/enterpriseCertification' })
              }
            }

          }).catch((err) => {
            next(false);
          })
        } else //没认证
          next({ path: '/enterpriseCertification' })
      }
    }

  } else {
    next(false)
  }

}
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    //个人信息界面
    {
      path: '/user',
      name: 'user',
      component: resolve => require(["@/page/userInfoPage"], resolve),
      children: [
        {
          // 企业资料
          path: '/enterpriseInfor',
          name: 'userEnterpriseInfor',
          component: resolve => require(["@/page/userInfoPage/components/enterpriseInfor"], resolve),
          beforeEnter: (to, from, next) => {
            userCenter(to, from, next)
          }
        },
        { // 企业资料修改
          path: '/enterpriseEdit',
          name: 'userEnterpriseEdit',
          component: resolve => require(["@/page/userInfoPage/components/enterpriseEdit"], resolve),
          beforeEnter: (to, from, next) => {
            userCenter(to, from, next)
          }
        },
        {
          // 安全中心
          path: '/securityCenter',
          name: 'userSecurityCenter',
          component: resolve => require(["@/page/userInfoPage/components/securityCenter"], resolve),
          beforeEnter: (to, from, next) => {
            let id = sessionStorage.getItem("id")
            if (id == undefined) {
              next(false)
            } else {
              next();
            }
          }
        },
        {
          // 安全中心修改
          path: '/security',
          name: 'userSecurity',
          component: resolve => require(["@/page/userInfoPage/components/security"], resolve),
          beforeEnter: (to, from, next) => {
            let id = sessionStorage.getItem("id")
            if (id == undefined) {
              next(false)
            } else {
              next();
            }
          }
        },
        {
          // 成果申报
          path: '/scientificAchievement',
          name: 'userScientificAchievement',
          component: resolve => require(["@/page/userInfoPage/components/scientificAchievement"], resolve),
          beforeEnter: (to, from, next) => {
            userCenter(to, from, next)
          }
        },
        {
          // 成果申报列表
          path: '/scientificAchieveTable',
          name: 'userScientificAchieveTable',
          component: resolve => require(["@/page/userInfoPage/components/scientificAchieveTable"], resolve),
          beforeEnter: (to, from, next) => {
            userCenter(to, from, next)
          }
        },
        {
          // 技术需求发布
          path: '/technicalRequirePublish',
          name: 'userTechnicalRequirements',
          props: (route) => route.query,
          component: resolve => require(['@/page/userInfoPage/components/technicalRequirePublish'], resolve),
          beforeEnter: (to, from, next) => {
            userCenter(to, from, next)
          }
        },
        {
          // 技术需求列表
          path: '/technicalRequire',
          name: 'userTechnicalRequire',
          component: resolve => require(['@/page/userInfoPage/components/technicalRequire'], resolve),
          beforeEnter: (to, from, next) => {
            userCenter(to, from, next)
          }
        },
        {
          // 企业项目列表
          path: '/companyProjectList',
          name: 'companyProjectList',
          component: resolve => require(['@/page/userInfoPage/components/companyProjectList'], resolve),
          beforeEnter: (to, from, next) => {
            userCenter(to, from, next)
          }
        },
        {
          // 企业项目合同页
          path: '/companyProjectContract',
          name: 'companyProjectContract',
          component: resolve => require(['@/page/userInfoPage/components/companyProjectContract'], resolve),
          beforeEnter: (to, from, next) => {
            userCenter(to, from, next)
          }
        },
        {
          // 企业项目立项
          path: '/companyProjectApply',
          name: 'companyProjectApply',
          component: resolve => require(['@/page/userInfoPage/components/companyProjectApply'], resolve),
          beforeEnter: (to, from, next) => {
            userCenter(to, from, next)
          }
        },
        {
          // 企业项目详情
          path: '/companyProjectDetails',
          name: 'companyProjectDetails',
          component: resolve => require(['@/page/userInfoPage/components/companyProjectDetails'], resolve),
          beforeEnter: (to, from, next) => {
            userCenter(to, from, next)
          }
        }
      ],
    },
    {
      // 创新创业详情
      path: '/innovationDetails',
      name: 'innovationDetails',
      component: resolve => require(["@/page/innovationDetailsPage/innovationDetailsPage"], resolve)
    },
    {
      // 重点企业
      path: '/keyEnterprises',
      name: 'keyEnterprises',
      component: resolve => require(["@/page/keyEnterprisesPage/keyEnterprisesPage"], resolve)
    },
    {
      // 科技服务页面
      path: '/scienceServer',
      name: 'scienceServer',
      component: resolve => require(["@/page/scienceServerPage/scienceServerPage"], resolve)
    },
    {//首页
      path: '/',
      name: 'Home',
      component: resolve => require(["@/page/Home/Home"], resolve)
    },
    {
      // 产学研服务
      path: '/researchServices',
      name: 'researchServices',
      component: resolve => require(["@/page/researchServicesPage/researchServicesPage"], resolve)
    },
    {
      //提交成功
      path: '/success',
      name: 'success',
      component: resolve => require(["@/page/successPage/successPage"], resolve)
    },
    {
      // 科技专家详情页面
      path: '/talentInfo',
      name: 'talentInfo',
      component: resolve => require(["@/page/talentInfoPage/talentInfoPage"], resolve)
    },
    { // 科技专家
      path: '/talentTank',
      name: 'talentTank',
      component: resolve => require(["@/page/talentTankPage/talentTankPage"], resolve)
    },
    { // 科技成果
      path: '/achievements',
      name: 'achievements',
      component: resolve => require(["@/page/achievementsPage/achievementsPage"], resolve)
    },
    {
      // 科技成果详情页面
      path: '/achievementDetail',
      name: 'achievementDetail',
      props: route => { return route.query },
      component: resolve => require(["@/page/achievementDetialPage"], resolve)
    },
    {
      // 科技成果需求详情
      path: '/achievementRequire',
      name: 'achievementRequire',
      props: route => { return route.query },
      component: resolve => require(["@/page/achievementRequirePage"], resolve)
    },
    {
      // 通知公告列表
      path: '/notice',
      name: 'notice',
      component: resolve => require(["@/page/noticePage/noticePage"], resolve)
    },
    {
      // 生物医药页面
      path: '/biomedicine',
      name: 'biomedicine',
      component: resolve => require(["@/page/biomedicinePage/biomedicinePage"], resolve)
    },
    {
      // 生物医药详情页面
      path: '/biomedicineDetail',
      name: 'biomedicineDetail',
      props: route => { return route.query },
      component: resolve => require(["@/page/biomedicineDetailPage"], resolve)
    },
    {
      // 资源对接页面
      path: '/resources',
      name: 'resources',
      component: resolve => require(["@/page/resourcesPage/resourcesPage"], resolve)
    },
    { // 科技政策
      path: '/techology',
      name: 'techology',
      component: resolve => require(["@/page/technologyPage/technologyPage"], resolve)
    },
    { // 特色产业
      path: '/iframe',
      name: 'iframe',
      component: resolve => require(["@/page/iframe/iframe"], resolve)
    },
    {
      //科技资讯
      path: '/technologyInfor',
      name: 'technologyInfor',
      component: resolve => require(["@/page/technologyInforPage/technologyInforPage"], resolve)
    },
    {
      //内容通知详情
      path: '/contentDetails',
      name: 'contentDetails',
      props: route => { return route.query },
      component: resolve => require(["@/page/contentDetailsPage/contentDetailsPage"], resolve)
    },
    {
      // 创新创业
      path: '/innovation',
      name: 'innovation',
      component: resolve => require(["@/page/innovationPage"], resolve)
    },
    {
      //科技扶贫
      path: '/povertyAlleviation',
      name: 'povertyAlleviation',
      component: resolve => require(["@/page/povertyAlleviation/povertyAlleviation"], resolve)
    },
    {
      //科技扶贫
      path: '/poverty',
      name: 'poverty',
      component: resolve => require(["@/page/povertyPage/povertyPage"], resolve)
    },
    {
      // 企业详情
      path: '/enterpriseDetail',
      name: 'enterpriseDetail',
      props: route => { return route.query },
      component: resolve => require(["@/page/enterpriseDetailPage"], resolve)
    }, {
      // 用户注册
      path: '/register',
      name: 'register',
      component: resolve => require(['@/page/registerPage'], resolve)
    }, {
      // 用户登录
      path: '/login',
      name: 'login',
      component: resolve => require(['@/page/loginPage'], resolve)
    }, {
      // 重设密码
      path: '/resetPassword',
      name: 'resetPassword',
      component: resolve => require(['@/page/resetPasswordPage'], resolve)
    }, {
      // 企业认证
      path: '/enterpriseCertification',
      name: 'enterpriseCertification',
      component: resolve => require(['@/page/enterpriseCertificationPage'], resolve),
      beforeEnter: (to, from, next) => {
        let id = sessionStorage.getItem("id");
        let cert = store.state.certificationStatus
        if (cert == 2 || cert == 1 || id == undefined) {
          next(false)
        } else {
          if (cert == '') { //数据刷新了
            ajax('/pc/company/getCompanyOne', { id: id }, 'POST').then((res) => {
              if (res.data.certificationStatus == 2 || res.data.certificationStatus == 1 || id == undefined) { //认证了
                next(false);
              } else { // 未认证
                next()
              }
            }).catch((err) => {
              next(false);
            })
          } else { // 未认证
            next();
          }

        }
      }
    }, {
      path: '/incubationService',
      component: resolve => require(['@/page/innovationDetailsPage/IncubationService'], resolve)
    }, {
      path: '/financingServices',
      component: resolve => require(['@/page/innovationDetailsPage/financingServices'], resolve)
    }, {
      path: '/brandDesignService',
      component: resolve => require(['@/page/innovationDetailsPage/brandDesignService'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/routers/index.js